import { ReportsStore } from "store/reports.store"
import { ViewModelClass } from "store/utils/ViewModel"

class MembershipReportViewModelClass extends ViewModelClass {
    init = async (from: string, to: string) => {
      this.startLoading()
      await ReportsStore.loadReferrerReport(from, to)
      this.stopLoading()
    }
  }
  
  export const ReferrersReportViewModel = new MembershipReportViewModelClass()
